export const fillLinearGradient = (layer) => {
  const numbers = layer.legend.split(";").map(l=> {
    return "#"+l.split(":")[1]
  }).join(", ")
  return `linear-gradient(to right, ${numbers})`
}